/**
 * Created by Ning Jiang on 3/20/2017.
 */

/**
 * Modified by Pradeep Kumar on 01/18/2019.
 */

import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {CreepyCarnivalTwoServerDataParser} from "../CreepyCarnivalTwoServerDataParser";
import {ICreepyCarnivalTwoGameData} from "./ICreepyCarnivalTwoServerData";
import {CreepyCarnivalTwo} from "../../CreepyCarnivalTwo";
import {CreepyCarnivalTwoGameMode} from "../../gamemode/CreepyCarnivalTwoGameMode";

export class CreepyCarnivalTwoParsedGameData extends SpinParsedGameData {

    private readonly _respinPositionsAfter: any[];
    private readonly _specialSymbolsArray: any[];
    private readonly _payoutWinMultiplier: number;
    private readonly _specialSymbolsLengthAfter: number;
    private readonly _specialSymbolsLengthBefore: number;
    private readonly _specialSymbolsLength: number;
    private readonly _respinPlayed: number;
    private readonly numberOfExtraFreespinsAwarded: number;

    private readonly _winPositions: boolean[][];
    private readonly _isRestore: boolean;


    constructor(rawData: ICreepyCarnivalTwoGameData, dataParser: CreepyCarnivalTwoServerDataParser) {
        super(rawData, dataParser);

        this._isRestore = dataParser.parseIsRestoreState(rawData);
        this._respinPositionsAfter = dataParser.parseRespinPositionsAfter(rawData);
        this._specialSymbolsLength = dataParser.calculateSpecialSymbolsLength(rawData);
        this._specialSymbolsLengthAfter = dataParser.calculateSpecialSymbolsLengthAfter(rawData);
        this._specialSymbolsLengthBefore = dataParser.calculateSpecialSymbolsLengthBefore(rawData);
        this._specialSymbolsArray = dataParser.getSpecialSymbolsArray(rawData);
        this._payoutWinMultiplier = rawData.payoutWinMultiplier;
        this._respinPlayed = rawData.respinPlayed;
        this.numberOfExtraFreespinsAwarded = rawData.numberOfExtraFreespinsAwarded;
        this._winPositions = dataParser.parseWinPositions(rawData);
    }

    public get getSpecialSymbolsArray(): any[] {
        return this._specialSymbolsArray;
    }

    public get isRestoreState(): boolean {
        return this._isRestore;
    }

    public get specialSymbolsLengthAfter(): number {
        return this._specialSymbolsLengthAfter;
    }

    public get specialSymbolsLengthBefore(): number {
        return this._specialSymbolsLengthBefore;
    }

    public get specialSymbolsLength(): number {
        return this._specialSymbolsLength;
    }

    public get respinPositions(): any[] {
        return this._respinPositionsAfter;
    }

    public get multiplier(): number {
        return this._payoutWinMultiplier;
    }

    public get respinsPlayedCount(): number {
        return this._respinPlayed;
    }

    public get winPositions(): boolean[][] {
        return this._winPositions;
    }

    protected isFeatureTotalWin(): boolean {
        return (this.mode === CreepyCarnivalTwoGameMode.RESPIN || this.mode === CreepyCarnivalTwoGameMode.RESPIN_FREESPIN || this.mode === CreepyCarnivalTwoGameMode.STAR_SPIN);
    }

    protected isNextFeatureTotalWin(): boolean {
        return (this.nextMode === CreepyCarnivalTwoGameMode.RESPIN || this.nextMode === CreepyCarnivalTwoGameMode.RESPIN_FREESPIN || this.nextMode === CreepyCarnivalTwoGameMode.STAR_SPIN);
    }

    public extraFreespinsAwarded(): number {
        return this.numberOfExtraFreespinsAwarded;
    }

    // protected isRespin():boolean {
    //     return this.mode === CreepyCarnivalTwoGameMode.RESPIN;
    // }
    // protected isNextRespin():boolean {
    //     return this.nextMode === CreepyCarnivalTwoGameMode.RESPIN;
    // }

}